import "./privacy-policy.less";

import{PrivacyPolicyModalController} from"./privacy-policy-modal.controller";
import{PrivacyPolicyDirective} from"./privacy-policy.directive";

import PrivacyPolicyTpl from "./privacy-policy.tpl";
import PrivacyPolicyModalHtml from "./privacy-policy.modal.html";


let privacyPolicyRegister: ModuleRegistration.Register = {
    regist: function (appModule: angular.IModule) {
        appModule.controller({
            privacyPolicyModalCtrl: PrivacyPolicyModalController
        })
        .directive({
            privacyPolicy:PrivacyPolicyDirective
        })
        .run(["$templateCache", function ($templateCache) {
            $templateCache.put("privacy-policy.html", PrivacyPolicyTpl),
            $templateCache.put("privacy-policy-modal.html", PrivacyPolicyModalHtml)
        }])
    }
}

export { privacyPolicyRegister }